import PageBuilderFooter from "./PageBuilderFooter";

export default PageBuilderFooter;